import * as api from '../../services/microsite'

export const FETCH_MICROSITE= 'FETCH_MICROSITE';




export const fetchMicrosites = (params, pagination, sort, extra) => {

    return {
        type: FETCH_MICROSITE,
        payload: {
            promise: api.findMicrosites(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/microsite.js